import {
  Button,
  ButtonProps,
  ColorKey,
  DropdownMenuGroup as WillowDropdownMenuGroup,
  DropdownMenuItem as WillowDropdownMenuItem,
  DropdownRadioItem as WillowDropdownRadioItem,
  DropdownSeparator as WillowDropdownSeparator,
  IconButton,
} from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import { StyledDropdownMenuItemProps } from './types'

const colorMap: Record<NonNullable<ButtonProps['color']>, ColorKey> = {
  destructive: 'alert',
  primary: 'brand',
  secondary: 'selection',
  tertiary: 'textPrimary',
}

const dropdownItemStyles = css<StyledDropdownMenuItemProps>`
  padding: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[6]};
  border-radius: ${({ theme }) => theme.space[2]};
  &:hover {
    filter: unset; // remove filter that comes from Button and ButtonLink components
  }
  color: ${({ theme, $color }) => theme.colors[colorMap[$color || 'tertiary']]};
  &[data-status='active'] {
    color: ${({ theme }) => theme.colors.selection};
  }
`

export const DropdownMenuItem = styled(
  WillowDropdownMenuItem
)<StyledDropdownMenuItemProps>`
  ${dropdownItemStyles}
`

export const DropdownRadioItem = styled(
  WillowDropdownRadioItem
)<StyledDropdownMenuItemProps>`
  ${dropdownItemStyles}

  &[data-state='checked'] {
    color: ${({ theme }) => theme.colors.selection};
  }
`

export const DropdownMenuGroup = styled(WillowDropdownMenuGroup)`
  padding: ${({ theme }) => theme.space[2]} 0;
  &:only-child {
    padding: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
`

export const DropdownSeparator = styled(WillowDropdownSeparator)`
  margin: 0 -${({ theme }) => theme.space[2]};
`

export const DropdownMenuIconButtonTrigger = styled(IconButton)`
  &[data-state='open'] {
    background-color: ${({ theme }) => theme.colors.infoLight};
    color: ${({ theme }) => theme.colors.selection};
  }
`
export const DropdownMenuButtonTrigger = styled(Button)`
  &[data-state='open'] {
    background-color: ${({ theme }) => theme.colors.infoLight};
    border-color: ${({ theme }) => theme.colors.selection};
  }
`
